module.exports = __webpack_public_path__ + "img/stamp-fish-autumn.8bba2351.png";